import type { components } from '@heidi/schema/ml-scribe';
import type { UseQueryResult } from '@tanstack/react-query';
import type { ComponentType } from 'react';

export type LiveTranscriptions = components['schemas']['LiveTranscriptResponse'];

export interface FdeUiHost {
  useQueryLiveTranscriptBySessionId: (
    sessionId: string
  ) => Pick<UseQueryResult<LiveTranscriptions>, 'data'>;
  useMutateUpdateContextContent: () => {
    mutate: (input: { context: string[]; sessionId: string }) => void;
  };
  isProductFeedbackAvailable: boolean;
}

export interface FdeSettingsUiHost {
  SettingsPageHeader: ComponentType<{ title: string; group: string }>;
  isGlobalAdmin: () => boolean | undefined;
}

let uiHost: FdeUiHost | null = null;
let settingsUiHost: FdeSettingsUiHost | null = null;

export const configureFdeUiHost = (next: FdeUiHost): void => {
  uiHost = next;
};

export const getFdeUiHost = (): FdeUiHost => {
  if (!uiHost) {
    throw new Error('[fde/ui] not configured');
  }
  return uiHost;
};

export const configureFdeSettingsUiHost = (next: FdeSettingsUiHost): void => {
  settingsUiHost = next;
};

export const getFdeSettingsUiHost = (): FdeSettingsUiHost => {
  if (!settingsUiHost) {
    throw new Error('[fde/settings-ui] not configured');
  }
  return settingsUiHost;
};
